/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgHandHeart = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M17 12a1 1 0 0 1 .98 1.196L17 13l.98.196v.004l-.002.006-.003.017-.012.054a9.588 9.588 0 0 1-.233.82 9.78 9.78 0 0 1-.873 1.918c-.195.326-.43.661-.703.985H21a1 1 0 0 1 .8 1.6c-1.635 2.18-3.558 3.285-5.083 3.84-.76.276-1.42.416-1.899.487a7.247 7.247 0 0 1-.74.071l-.05.002H14v-1l.001 1c-2.08 0-3.9-.26-5.197-.52a23.12 23.12 0 0 1-1.535-.359L6.846 22H2v-8h4.764l3.789-1.894.106-.046A1 1 0 0 1 11 12zm-9 3.618v4.625c.308.08.712.18 1.196.277 1.202.24 2.885.48 4.804.48h.013c.019 0 .052-.003.097-.006a5.23 5.23 0 0 0 .415-.046 7.787 7.787 0 0 0 1.508-.388A8.724 8.724 0 0 0 18.7 19H12a1 1 0 1 1 0-2c1.503 0 2.483-.915 3.143-2.015.201-.335.36-.675.488-.985h-4.395zM4 20h2v-4H4zM14.227 2C15.74 2 17 3.206 17 4.736v.082a2.8 2.8 0 0 1-.844 2L13.2 9.715l-.7.684-.7-.684-2.956-2.897a2.8 2.8 0 0 1-.844-2v-.082C8 3.206 9.26 2 10.772 2c.631 0 1.24.213 1.728.597A2.797 2.797 0 0 1 14.227 2zm0 2a.788.788 0 0 0-.61.284L12.5 5.652l-1.117-1.368a.788.788 0 0 0-.61-.284.755.755 0 0 0-.773.736v.082a.8.8 0 0 0 .243.572L12.5 7.599l2.257-2.21.055-.06A.796.796 0 0 0 15 4.82v-.083A.755.755 0 0 0 14.227 4z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgHandHeart as HandHeart };
